import { censusGraphs } from '../../../packages/configs/census-graphs';

import {
  census,
  foreclosureGraphs,
  heatmap,
  impact,
  occupancyGraphs,
  occupancyInformation,
  parcelDetails,
  saleInfo,
  structureGraphs,
  taxInformationMi,
  taxStatusMI,
  walkscore,
  zoningGraphs,
  // codeEnforcementReport,
} from '../../../packages/configs';

parcelDetails[1].options = ['PRINT', 'DIRECTIONS'];

export const parcelReport = {
  id: 'PARCEL_REPORT',
  sections: [
    {
      title: 'Property Profile',
      titleSelector: 'parcels[0].address',
      properties: [
        ...parcelDetails,
        {
          column: 'neighborhood',
          label: 'Neighborhood Planning Council',
          type: 'TEXT',
        },
        ...taxStatusMI,
        ...occupancyInformation,
        ...saleInfo(),
        ...walkscore(),
        ...impact,
        ...occupancyGraphs({ after: 2009 }),
        ...structureGraphs({ after: 2009 }),
        ...taxInformationMi({ after: 2009 }),
        ...foreclosureGraphs({ after: 2009 }),
        ...zoningGraphs,
        // ...codeEnforcementReport.filter(({ key }) => key !== 'crime_incident'),
        ...census,
        ...censusGraphs(),
        ...heatmap,
      ],
    },
  ],
};
